import { createContext, useContext, useMemo } from "react";

type AnalyticsContextProviderProps = {
  properties: Record<string, unknown>;
};

type AnalyticsContextProviderState = {
  properties: Record<string, unknown>;
};

export const AnalyticsContext = createContext<AnalyticsContextProviderState>({
  properties: {},
});

export const AnalyticsContextProvider = ({
  properties,
  children,
}: React.PropsWithChildren<AnalyticsContextProviderProps>) => {
  const parentProperties = useContext(AnalyticsContext).properties;

  const state = useMemo(
    () => ({
      properties: {
        ...parentProperties,
        ...properties,
      },
    }),
    [parentProperties, properties],
  );

  return (
    <AnalyticsContext.Provider value={state}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalyticsContext = () => {
  return useContext(AnalyticsContext).properties;
};
